import React from "react";
import {
  useNavigate
} from "react-router-dom";
import { Box, Stepper, Step, StepLabel, Button, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useReservation } from "./ReservationContext";
import ReservationStep1 from "./ReservationStep1";
import ReservationStep2 from "./ReservationStep2";
import ReservationStep3 from "./ReservationStep3";
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './ColorTheme';

const steps = ['Datum und Personen', 'Menü wählen', 'Reservierung abschließen'];

export default function ReservationComponent() {
  const { reservationState, handleNext, handleBack, handleReset, handleCloseDialog } = useReservation();
  const { activeStep, slides, openErrorDialog, errorDialogMessage } = reservationState;
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>
      <div className="content">
        <Box sx={{ width: "100%", paddingTop: "10px" }}>
          <Stepper
            sx={{
              '& .MuiStepLabel-root .Mui-completed': {
                color: '#4b949c',
              },
              '& .MuiStepLabel-root .Mui-active': {
                color: '#4b949c',
              },
              '& .MuiStepConnector-line': {
                borderTopWidth: '2px',
              }
            }} activeStep={activeStep} >
            {
              steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>

                  </Step>
                );
              })
            }
          </Stepper>
          {activeStep === 3 ? (
            <>
              <Typography
                sx={{
                  mt: 4,
                  mb: 3,
                  fontSize: '24px',
                  fontWeight: 600,
                  color: '#324b4e'
                }}
              >
                ✅ Reservierung erfolgreich!
              </Typography>
              <Button
                variant="contained"
                color="baerendark"
                sx={{
                  mt: 2,
                  borderRadius: '24px',
                  padding: '12px 32px',
                  fontSize: '16px',
                  fontWeight: 600,
                  textTransform: 'none',
                  boxShadow: '0 4px 12px rgba(50, 75, 78, 0.25)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: '0 6px 20px rgba(50, 75, 78, 0.35)',
                    transform: 'translateY(-2px)',
                  }
                }}
                onClick={() => {
                  handleReset();
                  navigate('/')
                }}
              >
                Zur Startseite
              </Button>
            </>
          ) : (
            <>
              <Typography sx={{ mt: 2, mb: 1 }}>
                {activeStep === 0 && <ReservationStep1 />}
                {activeStep === 1 && <ReservationStep2 />}
                {activeStep === 2 && <ReservationStep3 />}
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "row" }} className={"padded"}>
                <Box
                  sx={{
                    position: "fixed",
                    bottom: "56px",
                    width: "auto",
                    height: "56px",
                    left: "10px",
                    border: "0px solid black",
                    borderBottom: "none",
                    borderLeft: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                  }}
                >
                  {(activeStep !== 0) &&
                    <Button
                      variant="contained"
                      color="baerendark"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{
                        borderRadius: '24px',
                        padding: '10px 24px',
                        fontSize: '15px',
                        fontWeight: 600,
                        textTransform: 'none',
                        boxShadow: '0 4px 12px rgba(50, 75, 78, 0.25)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          boxShadow: '0 6px 16px rgba(50, 75, 78, 0.35)',
                        }
                      }}
                    >
                      ← Zurück
                    </Button>
                  }
                </Box>
                <Box sx={{ flex: "1 1 auto" }} />
                <Box
                  sx={{
                    position: "fixed",
                    bottom: "56px",
                    width: "auto",
                    height: "56px",
                    right: "10px",
                    border: "0px solid black",
                    borderBottom: "none",
                    borderRight: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                  }}
                >
                  <Button
                    color={activeStep === 2 ? "baeren" : "baerendark"}
                    variant="contained"
                    onClick={handleNext}
                    sx={{
                      borderRadius: '24px',
                      padding: '10px 32px',
                      fontSize: '15px',
                      fontWeight: 600,
                      textTransform: 'none',
                      boxShadow: '0 4px 12px rgba(75, 148, 156, 0.25)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 6px 20px rgba(75, 148, 156, 0.35)',
                        transform: 'translateY(-2px)',
                      }
                    }}
                  >
                    {activeStep === 2 ? "✓ Reservieren!" : "Weiter →"}
                  </Button>
                </Box>
              </Box>
            </>
          )}
        </Box>
        <Dialog open={openErrorDialog} onClose={handleCloseDialog}>
          <DialogTitle>Fehler</DialogTitle>
          <DialogContent>
            <DialogContentText>{errorDialogMessage}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}
